module.exports = __webpack_public_path__ + "img/12.39d71931.jpg";